<template>
  <el-container>
    <el-main style="width: 100%; height: 100%">
      <div style="margin-bottom: 30px">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item class="item_font">个人设置</el-breadcrumb-item>
          <el-breadcrumb-item
            ><span class="item_font">修改密码</span></el-breadcrumb-item
          >
        </el-breadcrumb>
      </div>
      <div style="width: 400px; margin: 60px auto" class="item_font">
        <el-form
          id="selectForm"
          label-position="right"
          :rules="rules"
          label-width="100px"
          :model="form"
        >
          <el-form-item prop="oldWord" label="原密码:"
            ><el-input
              type="password"
              v-model.trim="form.oldWord"
              placeholder="请输入原密码"
              @keyup.enter.native="nextInputps(1)"
            ></el-input
          ></el-form-item>
          <el-form-item prop="newWord" label="新密码:"
            ><el-input
              type="password"
              v-model.trim="form.newWord"
              placeholder="请输入6~15位新密码，区分大小写"
              @keyup.enter.native="nextInputps(2)"
            ></el-input
          ></el-form-item>
          <el-form-item prop="newWord2" label="确认新密码:"
            ><el-input
              type="password"
              v-model.trim="form.newWord2"
              placeholder="请再次输入密码确认"
              @keyup.enter.native="nextInputps(0)"
            ></el-input
          ></el-form-item>
          <el-form-item style="margin-top: 60px">
            <el-button type="primary" @click="onSubmit" class="item_font"
              >修改密码</el-button
            >
            <!-- <el-button>取消</el-button> -->
          </el-form-item>
        </el-form>
      </div>
    </el-main>
  </el-container>
</template>

<script>
import { MessageBox } from "element-ui";
import md5 from "js-md5";
import Cookies from "js-cookie";
export default {
  data() {
    var validateNewword = (rule, value, callback) => {
      if (value !== this.form.newWord) {
        callback(new Error("请确保两次输入的密码一致"));
      } else {
        callback();
      }
    };
    return {
      form: {
        oldWord: "",
        newWord: "",
        newWord2: "",
      },
      rules: {
        oldWord: [{ required: true, message: "原密码不能为空" }],
        newWord: [
          { required: true, message: "新密码不能为空", trigger: "blur" },
          { min: 6, max: 15, message: "请输入6~15位新密码", trigger: "blur" },
        ],
        newWord2: [
          { required: true, message: "请确认新密码", trigger: "blur" },
          { validator: validateNewword, trigger: "blur" },
        ],
      },
    };
  },

  created() {
    console.log("ForgetPassword created function");
  },

  mounted() {
    console.log("ForgetPassword mounted function");
  },

  methods: {
    async onSubmit() {
      console.log("forgetpassword onSubmit");
      if (this.form.newWord != this.form.newWord2) {
        const tipMsg = "请确保两次输入的密码一致";
        MessageBox.alert(tipMsg, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: null,
          type: "warning",
          showCancelButton: false,
        });
      } else if (
        this.form.newWord.length < 6 ||
        this.form.newWord.length > 15
      ) {
        const tipMsg = "密码的长度为6-15位";
        MessageBox.alert(tipMsg, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: null,
          type: "warning",
          showCancelButton: false,
        });
      } else {
        var api = "/manager/user/updatePassword";
        const response = await this.util.postRequest({
          url: api,
          method: "POST",
          data: {
            oldPassword: md5(this.form.oldWord),
            newPassword: md5(this.form.newWord),
          },
        });
        if (response.resultCode === "10000") {
          let userAgent = navigator.userAgent.toLowerCase();
          let ipc = null;
          if (userAgent.indexOf("electron/") != -1) {
            ipc = this.$electron.ipcRenderer;
          }
          if (ipc) {
            ipc.send(
              "removeCookie",
              md5(JSON.parse(localStorage.getItem("username")))
            );
          } else {
            Cookies.remove(md5(JSON.parse(localStorage.getItem("username"))));
          }
          this.$message.success("密码修改成功");
        } else {
          this.$message.error(response.desc);
        }
      }
    },
    nextInputps(num) {
      var inputs = document.getElementsByTagName("input");
      console.log(inputs);
      inputs[num].focus();
    },
  },
};
</script>

<style lang="scss">
.div_container {
  margin: 50px auto;
  /* background-color: cyan; */
  width: 50%;
}
.el-form-item__label {
  @include change_size($font_size_normal);
}
</style>
